<template>
  <admin-layout>
    <template v-slot:breadcrumb>
      <ol class="breadcrumb bg-transparent mb-0 pb-0 pt-1 px-0 me-sm-6 me-5">
        <li class="breadcrumb-item text-sm">
          <a class="opacity-5 text-white" href="javascript:;">Pages</a>
        </li>
        <li
          class="breadcrumb-item text-sm text-white active"
          aria-current="page"
        >
          Dashboard
        </li>
      </ol>
    </template>

    <template v-slot:header>
      <h5 class="font-weight-bolder text-white mt-4 mb-0">Dashboard</h5>
    </template>

    <template #content>
      <div class="row">
        <div class="col-lg-3 col-md-6 col-12">
          <div class="mb-4 card">
            <div class="p-3 card-body">
              <div class="d-flex flex-row-reverse justify-content-between mb-4">
                <div>
                  <div
                    class="text-center icon icon-shape bg-gradient-primary border-radius-2xl"
                  >
                    <i
                      class="text-lg opacity-10 ni ni-trophy"
                      aria-hidden="true"
                    ></i>
                  </div>
                </div>
                <div class="">
                  <div class="numbers">
                    <p class="mb-0 text-sm text-uppercase font-weight-bold">
                      Visualizações esse mês
                    </p>
                    <h5 class="font-weight-bolder">{{ vistoMesAtual }}</h5>
                    <span class="text-sm text-success"></span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-lg-3 col-md-6 col-12">
          <div class="mb-4 card">
            <div class="p-3 card-body">
              <div class="d-flex flex-row-reverse justify-content-between">
                <div>
                  <div
                    class="text-center icon icon-shape bg-gradient-danger border-radius-2xl"
                  >
                    <i
                      class="text-lg opacity-10 ni ni-like-2"
                      aria-hidden="true"
                    ></i>
                  </div>
                </div>
                <div class="">
                  <div class="numbers">
                    <p class="mb-0 text-sm text-uppercase font-weight-bold">
                      Você é favorido de
                    </p>
                    <h5 class="font-weight-bolder">{{ favoritoTotal }}</h5>
                    <span class="text-sm text-success"></span> Pessoas
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-lg-3 col-md-6 col-12">
          <div class="mb-4 card">
            <div class="p-3 card-body">
              <div class="d-flex flex-row-reverse justify-content-between mb-4">
                <div>
                  <div
                    class="text-center icon icon-shape bg-gradient-success border-radius-2xl"
                  >
                    <i
                      class="text-lg opacity-10 ni ni-paper-diploma"
                      aria-hidden="true"
                    ></i>
                  </div>
                </div>
                <div class="">
                  <div class="numbers">
                    <p class="mb-0 text-sm text-uppercase font-weight-bold">
                      Cupons
                    </p>
                    <h5 class="font-weight-bolder">{{ cuponsTotal }}</h5>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-lg-3 col-md-6 col-12">
          <div class="mb-4 card">
            <div class="p-3 card-body">
              <div class="d-flex flex-row-reverse justify-content-between mb-4">
                <div>
                  <div
                    class="text-center icon icon-shape bg-gradient-warning border-radius-2xl"
                  >
                    <i
                      class="text-lg opacity-10 ni ni-single-02"
                      aria-hidden="true"
                    ></i>
                  </div>
                </div>
                <div class="">
                  <div class="numbers">
                    <p class="mb-0 text-sm text-uppercase font-weight-bold">
                      Usuarios
                    </p>
                    <h5 class="font-weight-bolder">{{ userTotal }}</h5>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-lg-8 col-md-12 col-12">
          <div class="card pb-4">
            <div class="card-header pb-0">
              <div class="row">
                <div class="col-6 d-flex align-items-center">
                  <h6 class="mb-0">Visualização</h6>
                </div>
              </div>
            </div>
            <div class="card-body p-3 pb-0 mb-0 text-center">
              <Responsive class="w-full">
                <template #main="{ width }">
                  <Chart :size="{ width, height: 420 }" :data="data" :margin="margin">
                    <template #layers>
                      <Grid strokeDasharray="2,2" />
                      <Line :dataKeys="['mes', 'total']" />
                    </template>
                  </Chart>
                </template>
              </Responsive>
            </div>
          </div>
        </div>

        <div class="col-lg-4 col-md-12 col-12">
          <div class="card mb-2">
            <form @submit.prevent="salvaNota">
              <div class="card-header pb-0 d-flex">
                <h6>Anotações</h6>

                <button type="submit" class="btn btn-primary ms-auto">
                  Salvar
                </button>
              </div>
              <div class="form-group m-3">
                <div class="">
                  <textarea
                    type="textarea"
                    rows="16"
                    max-rows="20"
                    placeholder="Escreve suas anotações aqui, só você pode ver..."
                    class="form-control"
                    name="anotacao"
                    v-model="anotacao.nota"
                  >
                  </textarea>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </template>
  </admin-layout>
</template>

<script>
import AdminLayout from "@/Layouts/AdminLayout";
import { defineComponent, ref } from "vue";
import "vue3-carousel/dist/carousel.css";
import { Chart, Grid, Line, Responsive  } from "vue3-charts";
import moment from "moment";

export default {
  props: [
    "vistoMesAtual",
    "favoritoTotal",
    "cuponsTotal",
    "userTotal",
    "top_servicos",
    "noticias",
    "top_favoritos",
    "chartAcesso",
    "anotacao",
  ],

  data() {
    return {
      form: this.$inertia.form({
        anotacao: this.anotacao,
      }),

      margin: ref({
        left: 0,
        top: 20,
        right: 20,
        bottom: 0,
      }),

      direction: ref("horizontal"),

      data: [],
    };
  },

  watch: {
    anotacao: function (val) {
      this.form.anotacao = val;
    },
  },

  methods: {
    formatarData(data) {
      return moment(data).format("DD/MM/YYYY");
    },

    chartLine() {
      this.data = this.chartAcesso;
    },

    salvaNota() {
      this.$inertia.post(route("admin.dashboard.svnota"), this.form);
      console.log(this.form);
    },
  },

  components: {
    AdminLayout,
    Chart,
    Grid,
    Line,
    Responsive,
  },

  mounted() {
    this.chartLine();
  },
};
</script>

